export const withDocumentsReview = [

  'WHITHOUT_RATIFICATION_DEBTOR',
  'WHITHOUT_RATIFICATION_CLIENT',
];

export const withtRatification = [
  'WITH_RATIFICATION',
];
